export interface Dish {
  raw: string;
  name: string;
  cooked: string;
  isFood: boolean; //true: món chính, false: thành phần món cải thiện
  // Ghi chú định lượng theo món (backend mới bổ sung). Đọc cả 2 key cho chắc key JSON.
  dishNote?: string;
  dish_note?: string;
}

/** Hậu tố " (ghi chú)" nếu món có ghi chú định lượng; rỗng nếu không có. */
export const dishNoteSuffix = (dish: Pick<Dish, 'dishNote' | 'dish_note'>): string => {
  const note = (dish.dishNote ?? dish.dish_note ?? '').trim();
  return note ? ` (${note})` : '';
};

export interface MealDay {
  note: string;
  total: {
    lipid: number;
    glucid: number;
    calorie: number;
    protein: number;
  };
  dishes: Dish[];
  weekDay: number;
  datetime: string;
  afternoons: {
    dishes: Array<Array<string>>;
    calorie: number;
  };
}

export interface StructuredDataInfo {
  city: string;
  year: number;
  title: string;
  chef: string;
  nutritionSpecialist: string;
  menuAccountingOfficer: string;
  customerManagementOfficer: string;
  weekTitle: string;
}

/** Mirrors NutritionMenu/GateResource schema with narrowed structuredData for nutrition menu */
export interface ReplaceNutritionMenuModel {
  deletedAt?: string | null;
  searchStr: string;
  structuredData: {
    data: {
      info: StructuredDataInfo;
      items: MealDay[];
    };
    metadata: {
      isUsed: boolean; // có ăn hay không ăn: có ăn thì hiển thị thực đơn
      isCombineMenu: boolean; // thực đơn của cả giáo viên và học sinh
      isNutritionMenu: boolean; // Thực đơn có calo hay không có calo
      hasAfternoon: boolean; // Thực đơn có quà chiều hay không có quà chiều
    };
  };
  metadata: {
    v20241121: {
      year: number;
      month: number;
      week: number | null;
      day: number | null;
      state: string;
      [key: string]: unknown;
    };
    [key: string]: unknown;
  };
  parentId: string;
  type: string;
  updatedAt: string;
  [key: string]: unknown;
}

// export type NutritionMenuModel = typeof schemas.NutritionMenu._type & {
//   structuredData: {
//     data: {
//       info: StructuredDataInfo;
//       items: MealDay[];
//     };
//     metadata: {
//       isUsed: boolean;
//       isCombineMenu: boolean;
//       isNutritionMenu: boolean;
//       hasAfternoon: boolean;
//     };
//   };
// };
export type NutritionMenuModel = ReplaceNutritionMenuModel;
export interface NutritionMenuFilterModel {
  week?: number;
  /** `YYYY-MM` — khung thực đơn của năm học, KHÔNG phải số tháng của năm dương lịch. */
  month?: string;
  state?: NutritionMenuStatusEnum;
  template?: string;
}

export enum NutritionMenuStatusEnum {
  propose = 'propose',
  confirm = 'confirm',
  complete = 'complete',
}
